/** Shared pagination defaults for AI Detection tables (matches Alert Services). */
export const AI_DETECTION_DEFAULT_ROWS_PER_PAGE = 10;

export const AI_DETECTION_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];
